import * as React from 'react';
var Footer = function (_a) {
    var children = _a.children;
    return (React.createElement(React.Fragment, null,
        children,
        React.createElement("h5", null, "Informationen zu Datenschutz und Cookies")));
};
export default Footer;
//# sourceMappingURL=index.js.map